import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import { InstallAppButton } from './InstallAppPrompt';
import { LogoMarkB, ScalimmoWordmark } from './Logo';

export const Footer = () => {
    return (
        <footer className="bg-scalimmo-navy text-white" data-testid="footer">
            <div className="container-scalimmo py-16">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
                    {/* Brand */}
                    <div className="space-y-4">
                        <div className="flex items-center gap-2.5">
                            <LogoMarkB size={40} />
                            <ScalimmoWordmark size="md" variant="white" />
                        </div>
                        <p className="text-white/70 text-sm leading-relaxed">
                            La plateforme qui connecte vendeurs et agents immobiliers d'excellence.
                        </p>
                        <InstallAppButton className="border-scalimmo-gold/40 bg-scalimmo-gold/10 text-scalimmo-gold hover:bg-scalimmo-gold/20 hover:text-scalimmo-gold" />
                    </div>

                    {/* Links */}
                    <div>
                        <h4 className="font-heading text-lg font-semibold mb-4">Navigation</h4>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/agents" className="text-white/70 hover:text-white text-sm transition-colors">
                                    Trouver un agent
                                </Link>
                            </li>
                            <li>
                                <Link to="/top-performers" className="text-white/70 hover:text-scalimmo-gold text-sm transition-colors">
                                    Top Performers
                                </Link>
                            </li>
                            <li>
                                <Link to="/register" className="text-white/70 hover:text-white text-sm transition-colors">
                                    Devenir agent partenaire
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* For Agents */}
                    <div>
                        <h4 className="font-heading text-lg font-semibold mb-4">Pour les agents</h4>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/register" className="text-white/70 hover:text-white text-sm transition-colors">
                                    Inscription gratuite
                                </Link>
                            </li>
                            <li>
                                <span className="text-white/70 text-sm">
                                    Programme Top Performers
                                </span>
                            </li>
                            <li>
                                <span className="text-white/70 text-sm">
                                    Centre d'aide
                                </span>
                            </li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="font-heading text-lg font-semibold mb-4">Contact</h4>
                        <ul className="space-y-3">
                            <li className="flex items-center gap-2 text-white/70 text-sm">
                                <Mail className="w-4 h-4" />
                                contact@scalimmo.fr
                            </li>
                            <li className="flex items-center gap-2 text-white/70 text-sm">
                                <Phone className="w-4 h-4" />
                                <a href="tel:+33652396460" className="hover:text-scalimmo-gold transition-colors">06 52 39 64 60</a>
                            </li>
                            <li className="flex items-center gap-2 text-white/70 text-sm">
                                <MapPin className="w-4 h-4" />
                                Paris, France
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom */}
                <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-white/50 text-sm">
                        © 2024 Scalimmo. Tous droits réservés.
                    </p>
                    <div className="flex items-center gap-6">
                        <Link to="#" className="text-white/50 hover:text-white text-sm transition-colors">
                            Mentions légales
                        </Link>
                        <Link to="#" className="text-white/50 hover:text-white text-sm transition-colors">
                            Confidentialité
                        </Link>
                        <Link to="#" className="text-white/50 hover:text-white text-sm transition-colors">
                            CGU
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};
